import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { Link } from "react-router-dom";
import { API } from "../../../API";
import axios from "axios";

import { isAutheticated } from "../../auth/authhelper";
import Pagination from "../../pagination";
import swal from "sweetalert";
import { Player } from "video-react";
// import UserPaypal from "../../customer/UserPaypal";
import Footer from "../Footer";
import { Modal } from "react-bootstrap";

export default function SoComAdvisor() {
    const { token } = isAutheticated();
    const [data, setdata] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(15);
    const [showData, setShowData] = useState(data);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let res = await axios.get(`${API}/api/advisor/advisors`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log(res.data?.data
            )
            setdata(res.data?.data
            );
            setLoading(false);
        };
        fetchData();
    }, [success]);
    useEffect(() => {
        const loadData = () => {
            const indexOfLastPost = currentPage * itemPerPage;
            const indexOfFirstPost = indexOfLastPost - itemPerPage;
            setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
        };

        loadData();
    }, [data, currentPage, itemPerPage]);
    const handleDelete = async (id) => {
        // Show SweetAlert confirmation
        const status = await swal({
            title: "Are you sure?",
            text: "Do you want to delete this SoCom Advisor?",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        });

        // If the user confirms, proceed with deletion
        if (!status) {
            return;
        }

        try {
            // Send delete request
            const res = await axios.delete(
                `${API}/api/advisor/delete/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res) {
                setSuccess(!success); // Trigger state update or re-fetch
                swal("Deleted!", "SoCom Advisor has been deleted successfully.", "success");
            }
        } catch (error) {
            console.error("Error deleting SoCom Advisor:", error);
            swal("Error", "There was an issue deleting the Channel.", "error");
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        const action = currentStatus ? "suspend" : "activate";

        const confirm = await swal({
            title: `Are you sure?`,
            text: `Do you want to ${action} this SoCom Advisor?`,
            icon: "warning",
            buttons: ["Cancel", `Yes, ${action}`],
            dangerMode: true,
        });

        if (!confirm) return; // Exit if cancelled

        try {
            const res = await axios.patch(
                `${API}/api/advisor/toggle_SoComAdvisor_Status/${id}`,
                { isActive: !currentStatus },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res) {
                setSuccess((prev) => !prev); // Refresh data
                swal("Updated!", res.data.message, "success");
            }
        } catch (error) {
            console.error("Error toggling status:", error);
            swal("Error", "There was a problem updating the channel status.", "error");
        }
    };


    ////modals
    // ====== NETWORK CHANNEL MODAL STATES ======
    const [showModal, setShowModal] = useState(false);
    const [selectedAdvisor, setSelectedAdvisor] = useState(null);
    const [channels, setChannels] = useState([]);
    const [loadingChannels, setLoadingChannels] = useState(false);

    // ====== FETCH CHANNELS ======
    const refreshChannels = async () => {
        if (!selectedAdvisor) return;

        try {
            setLoadingChannels(true);

            const res = await axios.get(
                `${API}/api/advisor/channels/for-advisor/${selectedAdvisor}`,

                { headers: { Authorization: `Bearer ${token}` } }
            );

            setChannels(res.data.data || []);
        } catch (err) {
            console.error(err);
            swal("Error", "Failed to load network channels", "error");
        } finally {
            setLoadingChannels(false);
        }
    };

    // ====== LOAD WHEN ADVISOR SELECTED ======
    useEffect(() => {
        refreshChannels();
    }, [selectedAdvisor]);

    // ====== LINK CHANNEL ======
    const handleLink = async (channelId) => {
        const ok = await swal({
            title: "Add Channel?",
            text: "Do you want to Add this network channel?",
            icon: "warning",
            buttons: ["Cancel", "Add"],
        });

        if (!ok) return;

        await axios.patch(
            `${API}/api/advisor/link-network-channel/to-advisor`,
            {
                advisorId: selectedAdvisor,
                channelId,
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        swal("Added!", "Channel Added successfully", "success");
        refreshChannels();
    };

    // const handleLink = async (channelId) => {
    //     const ok = await swal({
    //         title: "Add Channel?",
    //         text: "Do you want to Add this network channel?",
    //         icon: "warning",
    //         buttons: ["Cancel", "Add"],
    //     });

    //     if (!ok) return;

    //     await axios.post(
    //         `${API}/api/advisor/link-network-channel`,
    //         {
    //             advisorId: selectedAdvisor,
    //             channelId,
    //         },
    //         { headers: { Authorization: `Bearer ${token}` } }
    //     );

    //     swal("Added!", "Channel Added successfully", "success");
    //     refreshChannels(); // ✅ instant UI update
    // };

    // ====== UNLINK CHANNEL ======
    // const handleUnlink = async (channelId) => {
    //     const ok = await swal({
    //         title: "Remove Channel?",
    //         text: "Do you want to Remove this network channel?",
    //         icon: "warning",
    //         buttons: ["Cancel", "Remove"],
    //         dangerMode: true,
    //     });

    //     if (!ok) return;

    //     await axios.post(
    //         `${API}/api/advisor/unlink-network-channel`,
    //         {
    //             advisorId: selectedAdvisor,
    //             channelId,
    //         },
    //         { headers: { Authorization: `Bearer ${token}` } }
    //     );

    //     swal("Removed!", "Channel Remove successfully", "success");
    //     refreshChannels(); // ✅ instant UI update
    // };
    const handleUnlink = async (channelId) => {
        const ok = await swal({
            title: "Remove Channel?",
            text: "Do you want to Remove this network channel?",
            icon: "warning",
            buttons: ["Cancel", "Remove"],
            dangerMode: true,
        });

        if (!ok) return;

        await axios.patch(
            `${API}/api/advisor/unlink-network-channel/from-advisor`,
            { channelId },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        swal("Removed!", "Channel removed successfully", "success");
        refreshChannels();
    };

    //model end

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='page-title-box d-flex align-items-center justify-content-between'>
                                <h4 className='mb-0'>Content Management - SoCom Advisors</h4>

                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>SoComOTT</Link>
                                        </li>
                                        <li className='breadcrumb-item'>Content Management - SoCom Advisors</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row ml-0 mr-0  mb-10">
                                        <div className="col-sm-12 col-md-6">&nbsp;</div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="dropdown d-block">
                                                <Link to="/SoCom_advisor/add">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary add-btn waves-effect waves-light float-right"
                                                    >
                                                        <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                                                        Add New SoCom Advisor
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive table-shoot">
                                        <table className="table table-centered table-nowrap mb-0">
                                            <thead className="thead-light">
                                                <tr className="text-center">
                                                    <th>SoCom Advisor Name</th>
                                                    <th>Thumbnail</th>
                                                    <th>Banner</th>
                                                    <th>Logo</th>
                                                    <th>Status</th>



                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Loading ? (
                                                    <tr>
                                                        <td colSpan="10" align="center" style={{ padding: "20px" }}>
                                                            <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                                                Loading...
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : showData?.length > 0 ? (
                                                    showData.map((item) => (
                                                        <tr key={item._id} className="text-center">
                                                            <td>{item.name}</td>
                                                            <td>
                                                                <img
                                                                    // src="https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png"
                                                                    src={item?.thumbnail?.url}
                                                                    alt="thumbnail"
                                                                    style={{
                                                                        width: "90px", // Set desired width
                                                                        height: "50px", // Set desired height
                                                                        objectFit: "fill", // Maintain aspect ratio
                                                                        display: "block", // Center horizontally
                                                                        margin: "0 auto", // Center horizontally
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <img
                                                                    // src="https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png"
                                                                    src={item?.banner?.url}
                                                                    alt="banner"
                                                                    style={{
                                                                        width: "120px", // Set desired width
                                                                        height: "60px", // Set desired height
                                                                        objectFit: "fill", // Maintain aspect ratio
                                                                        // display: "block", // Center horizontally
                                                                        margin: "0 auto", // Center horizontally
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <img
                                                                    src={item?.logo?.url}
                                                                    // src="https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png"
                                                                    alt="logo"
                                                                    style={{
                                                                        width: "90px", // Set desired width
                                                                        height: "50px", // Set desired height
                                                                        objectFit: "fill", // Maintain aspect ratio
                                                                        display: "block", // Center horizontally
                                                                        margin: "0 auto", // Center horizontally
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                {/* {lession?.launchDate &&
                                                     new Date(lession?.launchDate).toDateString()
                                                   } */}
                                                                {/* {console.log(lession?.video)}
                                                     {lession?.video &&
                                                       <button
                                                         className="badge badge-pill badge-success font-size-12"
                                                         onClick={() => downloadFile(lession?.video)}
                                                       >
                                                         Download
                                                       </button>} */}





                                                                {item?.status === "active" ? (

                                                                    <span className='badge badge-pill badge-success font-size-12'>
                                                                        Active
                                                                    </span>
                                                                ) : (
                                                                    <span className='badge badge-pill badge-soft-danger font-size-12'>
                                                                        Suspend
                                                                    </span>
                                                                )}</td>

                                                            <td>
                                                                <button
                                                                    className="btn btn-info btn-sm me-2"
                                                                    onClick={() => {
                                                                        setSelectedAdvisor(item._id);
                                                                        setShowModal(true);
                                                                    }}
                                                                >
                                                                    Network Channels
                                                                </button>

                                                                <button
                                                                    onClick={() => handleToggleStatus(item._id, item.status)}
                                                                    type="button"
                                                                    className={`btn btn-sm waves-effect waves-light btn-table me-2 ${item.status ? "btn-warning" : "btn-success"
                                                                        }`}
                                                                >
                                                                    {item.status === "active" ? "Suspend" : "Activate"}
                                                                </button>

                                                                <Link to={`/SoCom_advisor/edit/${item._id}`}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm waves-effect waves-light btn-table me-2"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </Link>
                                                                <button
                                                                    onClick={() => handleDelete(item._id)}
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm waves-effect waves-light btn-table"
                                                                    id="sa-params"
                                                                >
                                                                    Delete
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" className="text-center py-4" style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                                            No SoCom Advisor Found. Please add Channel to display here.
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <!-- end table-responsive --> */}
                                    <div className='row mt-20'>
                                        <div className='col-sm-12 col-md-6 mb-20'>
                                            <div
                                                className='dataTables_info'
                                                id='datatable_info'
                                                role='status'
                                                aria-live='polite'>
                                                Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                                                {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                                                {data.length} entries
                                            </div>
                                        </div>

                                        <div className='col-sm-12 col-md-6'>
                                            <div className='dataTables_paginate paging_simple_numbers float-right'>
                                                <ul className='pagination'>
                                                    <li
                                                        className={
                                                            currentPage === 1
                                                                ? "paginate_button page-item previous disabled"
                                                                : "paginate_button page-item previous"
                                                        }>
                                                        <a
                                                            href='#'
                                                            aria-controls='datatable'
                                                            data-dt-idx='0'
                                                            tabIndex='0'
                                                            className='page-link'
                                                            onClick={() =>
                                                                setCurrentPage((prev) => prev - 1)
                                                            }>
                                                            Previous
                                                        </a>
                                                    </li>

                                                    {!(currentPage - 1 < 1) && (
                                                        <li className='paginate_button page-item'>
                                                            <a
                                                                aria-controls='datatable'
                                                                data-dt-idx='1'
                                                                tabIndex='0'
                                                                href='#'
                                                                className='page-link'
                                                                onClick={(e) =>
                                                                    setCurrentPage((prev) => prev - 1)
                                                                }>
                                                                {currentPage - 1}
                                                            </a>
                                                        </li>
                                                    )}

                                                    <li className='paginate_button page-item active'>
                                                        <a
                                                            href='#'
                                                            aria-controls='datatable'
                                                            data-dt-idx='2'
                                                            tabIndex='0'
                                                            className='page-link'>
                                                            {currentPage}
                                                        </a>
                                                    </li>

                                                    {!(
                                                        (currentPage + 1) * itemPerPage - itemPerPage >
                                                        data.length
                                                    ) && (
                                                            <li className='paginate_button page-item '>
                                                                <a
                                                                    href='#'
                                                                    aria-controls='datatable'
                                                                    data-dt-idx='3'
                                                                    tabIndex='0'
                                                                    className='page-link'
                                                                    onClick={() => {
                                                                        setCurrentPage((prev) => prev + 1);
                                                                    }}>
                                                                    {currentPage + 1}
                                                                </a>
                                                            </li>
                                                        )}

                                                    <li
                                                        className={
                                                            !(
                                                                (currentPage + 1) * itemPerPage - itemPerPage >
                                                                data.length
                                                            )
                                                                ? "paginate_button page-item next"
                                                                : "paginate_button page-item next disabled"
                                                        }>
                                                        <a
                                                            href='#'
                                                            tabIndex='0'
                                                            className='page-link'
                                                            onClick={() =>
                                                                setCurrentPage((prev) => prev + 1)
                                                            }>
                                                            Next
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- container-fluid --> */}
            </div>
            {/* <!-- End Page-content --> */}

            {/* <footer className="footer">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <script>document.write(new Date().getFullYear())</script> © SoComOTT
                                        </div>
                   
                                    </div>
                                </div>
                            </footer> */}
            <Footer />
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Link: Network Channels
                    </Modal.Title>
                </Modal.Header>


                <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    {loadingChannels ? (
                        <div className="d-flex justify-content-center align-items-center py-5">
                            <div className="spinner-border text-primary" />
                        </div>
                    ) : channels.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            No channels available
                        </div>
                    ) : (
                        channels.map((ch) => (
                            <div
                                key={ch._id}
                                className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2"
                            >
                                {/* LEFT: Thumbnail + Name */}
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        src={ch?.thumbnail?.url}
                                        alt={ch.name}
                                        style={{
                                            width: "100px",
                                            height: "40px",
                                            objectFit: "cover",
                                            borderRadius: "4px",
                                            border: "1px solid #ddd"
                                        }}
                                    />
                                    <span style={{ fontWeight: 500 }}>{ch.name}</span>
                                </div>

                                {/* RIGHT: Button */}
                                {ch.isLinked ? (
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleUnlink(ch._id)}
                                    >
                                        Remove
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleLink(ch._id)}
                                    >
                                        Add
                                    </button>
                                )}
                            </div>
                        ))
                    )}
                </Modal.Body>
            </Modal>


        </div>
    );
}
